import { render, staticRenderFns } from "./MarketView.vue?vue&type=template&id=7818e4ba&scoped=true&"
import script from "./MarketView.vue?vue&type=script&lang=js&"
export * from "./MarketView.vue?vue&type=script&lang=js&"
import style0 from "./MarketView.vue?vue&type=style&index=0&id=7818e4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7818e4ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
